import { useMemo } from "react";
import { useCsAttribute } from "./useCsAttribute";
import { useLocalMultiSelectState } from "./useLocalMultiSelectState";
/**
 * Returns an object with the selected value assignments
 * @category CsAttribute
 * @export
 * @returns {Record<string, boolean>}
 */
export function useLocalCheckboxValues() {
    const attribute = useCsAttribute();
    const selectState = useLocalMultiSelectState();
    const attributeValues = attribute.values;
    const localValues = selectState[attribute.path];
    return useMemo(() => (attributeValues !== null && attributeValues !== void 0 ? attributeValues : []).reduce((memo, value) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, memo), { [value.value]: (_b = (_a = localValues === null || localValues === void 0 ? void 0 : localValues[value.value]) !== null && _a !== void 0 ? _a : value === null || value === void 0 ? void 0 : value.isSelected) !== null && _b !== void 0 ? _b : false }));
    }, {}), [attributeValues, localValues]);
}
//# sourceMappingURL=useLocalCheckboxValues.js.map